import { Box, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { Clipboard } from 'react-native'
import { SvgImage } from '../../../../comps/SvgImage'
import { MerchantStatus, merchantStatusString } from '../../../../data/static/data'
import { styles1 } from '../MIDSelector/styles'

const labelMidWithColon = 'MID:'
// const labelTidWithColon = 'TID:'
interface TitleComponentProps {
  merchantName: string
  mid: string
  tid?: string
  selectedMerchantStatus: string
  breakpoint: number
  onCopy: any
}

const TitleComponent: FC<TitleComponentProps> = ({
  merchantName,
  mid,
  selectedMerchantStatus,
  breakpoint,
  onCopy,
}: TitleComponentProps) => {
  const themedStyle = styles1(breakpoint)

  const handleCopy = () => {
    Clipboard.setString(mid)
    onCopy()
  }
  return (
    <Box {...themedStyle.titleContainer}>
      <Text color="BLACK" fontFamily="jiotype-bold" fontWeight="bold">
        {merchantName}
      </Text>
      <Spacer direction="vertical" size={7} />
      <Box
        flexDirection={'row'}
        justify={'center'}
        gap={8}
        testID="copy-mid"
        onPress={handleCopy}
        underlayColor={'TRANSPARENT'}>
        <Text fontFamily="jiotype-medium" color="LIGHT_BLACK" fontSize={11} testID="selected-mid">
          {/* {`${labelMidWithColon} ${mid} | ${labelTidWithColon} ${tid}`} */}
          {`${labelMidWithColon} ${mid}`}
        </Text>
        <SvgImage imageName={'copy'} width={10} height={10} />
      </Box>
      <Spacer size={7} />
      <Box {...themedStyle.cellStatusView[merchantStatusString[selectedMerchantStatus as MerchantStatus]]}>
        <Text {...themedStyle.cellStatusValue}>{merchantStatusString[selectedMerchantStatus as MerchantStatus]}</Text>
      </Box>
    </Box>
  )
}

export { TitleComponent }
